import fineui from "./index";

BI.extend(BI, fineui);
